import { useGridApiRef } from '@mui/x-data-grid-pro';
// eslint-disable-next-line import/no-internal-modules
import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import React, { ReactElement } from 'react';

export interface GridApiRefProp {
    gridApiRef: React.MutableRefObject<GridApiPro>;
}

export const withDataGridApi =
    <
        C extends React.ComponentType<GridApiRefProp & React.ComponentProps<C>>,
        ResolvedProps = Omit<React.ComponentProps<C>, keyof GridApiRefProp>,
    >(
        component: C,
    ): React.ComponentType<ResolvedProps> =>
    (props: ResolvedProps): ReactElement => {
        const gridApiRef = useGridApiRef();

        const finalProps = {
            ...props,
            gridApiRef,
        } as GridApiRefProp & React.ComponentProps<C>;

        return React.createElement(component, finalProps);
    };
